import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M0 12a12 12 0 1 0 24 0 12 12 0 1 0-24 0"
    }, null, -1)
  ]));
}
const basicShapePrimaryCircleEllipseRound = { render };
export {
  basicShapePrimaryCircleEllipseRound as default,
  render
};
//# sourceMappingURL=basic-shape-primary-circle-ellipse-round.svg.js.map
